import { useState, useContext } from "react";
import { TbDashboard, TbBuilding, TbBed, TbCalendarStats, TbTag,
         TbCalendarCheck, TbPencilPlus, TbStar, TbLogout,
         TbLayoutSidebarLeftCollapse, TbLayoutSidebarLeftExpand } from "react-icons/tb";
import Cookies from "js-cookie";
import { AuthAdminContext } from "../../clients/utils/AuthAdminContext";
import Dashboard from "../components/Dashboard";
import HotelSettings from "../components/HotelSettings/HotelSettings";
import Inventory from "../components/Inventory/InventoryPage";
import Reservations from "../components/Reservations/Reservations";
import TarifsPage from "../components/Tarifs/TarifsPage";
import Rooms from "../components/Rooms/Rooms";
import ReviewsModeration from "../components/Reviews/ReviewsModeration";
import Book from "../components/Book";

const NAV = [
  { section: "Principal" },
  { key: "dashboard",    label: "Dashboard",           icon: TbDashboard },
  { key: "hotel",        label: "Mon hébergement",           icon: TbBuilding },
  { divider: true },
  { section: "Gestion" },
  { key: "rooms",        label: "Chambres",            icon: TbBed },
  { key: "inventory",   label: "Disponibilités",      icon: TbCalendarStats },
  { key: "tarifs",       label: "Tarifs",              icon: TbTag },
  { divider: true },
  { section: "Réservations" },
  { key: "reservations", label: "Réservations",        icon: TbCalendarCheck },
  { key: "book",         label: "Nouvelle réservation",icon: TbPencilPlus },
  { divider: true },
  { section: "Autre" },
  { key: "reviews",      label: "Avis clients",        icon: TbStar },
];

export default function Admin() {
  const [activePage, setActivePage] = useState("dashboard");
  const [collapsed, setCollapsed]   = useState(false);
  const [needRatePlanMsg, setNeedRatePlanMsg] = useState(false);
  const { dispatch } = useContext(AuthAdminContext);

  const renderPage = () => {
    switch (activePage) {
      case "inventory":    return <Inventory setActivePage={setActivePage} />;
      case "rooms":        return <Rooms setActivePage={setActivePage} setNeedRatePlanMsg={setNeedRatePlanMsg} />;
      case "tarifs":       return <TarifsPage needRatePlanMsg={needRatePlanMsg} setNeedRatePlanMsg={setNeedRatePlanMsg} setActivePage={setActivePage} />;
      case "book":         return <Book />;
      case "reservations": return <Reservations />;
      case "reviews":      return <ReviewsModeration />;
      case "hotel":        return <HotelSettings />;
      default:             return <Dashboard setActivePage={setActivePage} />;
    }
  };

  const handleLogout = () => {
    dispatch({ type: "ADMIN_LOGOUT" });
    Cookies.remove("admin_token", { path: "/", domain: ".komorotel.com" });
  };

  return (
    <div className="flex h-screen overflow-hidden bg-[#F8FAFC]">

      {/* SIDEBAR */}
      <div className={`flex flex-col bg-white border-r border-gray-100 transition-all duration-200 shrink-0 ${collapsed ? "w-16" : "w-60"}`}>

        {/* Logo */}
        <div className="flex items-center justify-between px-4 py-4 border-b border-gray-100">
          {!collapsed && <span className="text-sm font-medium text-gray-900">Komorotel</span>}
          <button
            onClick={() => setCollapsed(c => !c)}
            className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 text-gray-400 hover:bg-gray-50 transition"
          >
            {collapsed
              ? <TbLayoutSidebarLeftExpand size={15} />
              : <TbLayoutSidebarLeftCollapse size={15} />}
          </button>
        </div>

        {/* Nav */}
        <nav className="flex-1 flex flex-col gap-0.5 px-2 py-2 overflow-y-auto">
          {NAV.map((item, i) => {
            if (item.divider) return <div key={i} className="h-px bg-gray-100 my-1 mx-1" />;
            if (item.section) return !collapsed
              ? <p key={i} className="text-[10px] font-medium text-gray-400 uppercase tracking-widest px-2 pt-2 pb-1">{item.section}</p>
              : null;

            const Icon = item.icon;
            const active = activePage === item.key;
            return (
              <button
                key={item.key}
                onClick={() => setActivePage(item.key)}
                title={collapsed ? item.label : undefined}
                className={`flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm transition-all text-left w-full
                  ${active ? "bg-[#eaf3de] text-[#3B6D11] font-medium" : "text-gray-500 hover:bg-gray-50 hover:text-gray-900"}`}
              >
                <Icon size={18} className="shrink-0" />
                {!collapsed && <span className="truncate">{item.label}</span>}
              </button>
            );
          })}
        </nav>

        {/* Bottom */}
        <div className="border-t border-gray-100 px-2 py-2">
          {!collapsed && (
            <div className="flex items-center gap-2.5 px-2.5 py-2 mb-1">
              <div className="w-7 h-7 rounded-full bg-[#eaf3de] text-[#3B6D11] flex items-center justify-center text-xs font-medium shrink-0">
                AD
              </div>
              <div className="overflow-hidden">
                <p className="text-xs font-medium text-gray-900 truncate">Admin</p>
                <p className="text-xs text-gray-400">Hôtelier</p>
              </div>
            </div>
          )}
          <button
            onClick={handleLogout}
            title={collapsed ? "Déconnexion" : undefined}
            className="flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm text-red-400 hover:bg-red-50 hover:text-red-600 transition w-full"
          >
            <TbLogout size={18} className="shrink-0" />
            {!collapsed && <span>Déconnexion</span>}
          </button>
        </div>
      </div>

      {/* MAIN */}
      <div className="flex-1 overflow-y-auto p-6">
        {renderPage()}
      </div>
    </div>
  );
}